export const DEAFULT_REGION = {
  id: 314,
  version: 2,
  deleted: false,
  active: true,
  name: 'Delhi',
  shortCode: null,
  slug: 'delhi',
  displayName: 'Delhi',
  displayNameHi: null,
  alternateName: null,
  level: 1,
  createdDate: '2020-09-08T11:55:31.415Z',
  location: {
    latitude: null,
    longitude: null,
  },
  country: {
    id: 103,
    version: 2,
    deleted: false,
    active: true,
    name: 'India',
    shortCode: 'IN',
    slug: 'india',
    displayName: 'India',
    displayNameHi: 'भारत',
    alternateName: null,
    level: 0,
    createdDate: '2020-09-08T11:35:40.786Z',
    language: null,
    hasStates: true,
    location: {
      latitude: null,
      longitude: null,
    },
  },
  label: 'Delhi (314)',
  value: 314,
};

export const DEAFULT_CITY = {
  id: 316,
  version: 2,
  deleted: false,
  active: true,
  name: 'Delhi',
  shortCode: null,
  slug: 'delhi',
  displayName: 'Delhi',
  displayNameHi: null,
  alternateName: null,
  level: 3,
  createdDate: '2020-09-08T11:55:31.431Z',
  metro: null,
  location: {
    latitude: null,
    longitude: null,
  },
  region: {
    id: 314,
    version: 2,
    deleted: false,
    active: true,
    name: 'Delhi',
    shortCode: null,
    slug: 'delhi',
    displayName: 'Delhi',
    displayNameHi: null,
    alternateName: null,
    level: 1,
    createdDate: '2020-09-08T11:55:31.415Z',
    location: {
      latitude: null,
      longitude: null,
    },
  },
  country: {
    id: 103,
    version: 2,
    deleted: false,
    active: true,
    name: 'India',
    shortCode: 'IN',
    slug: 'india',
    displayName: 'India',
    displayNameHi: 'भारत',
    alternateName: null,
    level: 0,
    createdDate: '2020-09-08T11:35:40.786Z',
    language: null,
    hasStates: true,
    location: {
      latitude: null,
      longitude: null,
    },
  },
  label: 'Delhi (316)',
  value: 316,
};

export const romanToInt = (s) => {
  const romanMap = { I: 1, V: 5, X: 10, L: 50, C: 100 };
  let total = 0,
    prev = 0;

  for (let i = s.length - 1; i >= 0; i--) {
    const curr = romanMap[s[i].toUpperCase()] || 0;
    total += curr < prev ? -curr : curr;
    prev = curr;
  }

  return total;
};

const CLASS_10_TO_12 = {
  classes: [
    {
      name: 'XI',
      level: 11,
    },
    {
      name: 'XII',
      level: 12,
    },
  ],
  id: 56934,
  version: 1,
  deleted: false,
  active: true,
  lowGrade: null,
  highGrade: null,
  schoolLevel: {
    classes: [
      {
        name: 'XI',
        level: 11,
      },
      {
        name: 'XII',
        level: 12,
      },
    ],
    id: 6,
    version: 1,
    deleted: false,
    active: true,
    name: 'Senior Secondary School (XI-XII)',
    displayName: 'Senior Secondary School (XI-XII)',
    level: 6,
  },
};

const CLASS_8_TO_10 = {
  schoolLevel: {
    classes: [
      {
        name: 'IX',
        level: 9,
      },
      {
        name: 'X',
        level: 10,
      },
    ],
    id: 5,
    version: 1,
    deleted: false,
    active: true,
    name: 'Secondary School (IX-X)',
    displayName: 'Secondary School (IX-X)',
    level: 5,
    country: null,
    value: 5,
    label: 'Secondary School (IX-X)',
  },
  classes: [
    {
      name: 'IX',
      level: 9,
    },
    {
      name: 'X',
      level: 10,
    },
  ],
};

const CLASS_6_TO_8 = {
  schoolLevel: {
    classes: [
      {
        name: 'VI',
        level: 6,
      },
      {
        name: 'VII',
        level: 7,
      },
      {
        name: 'VIII',
        level: 8,
      },
    ],
    id: 4,
    version: 1,
    deleted: false,
    active: true,
    name: 'Middle School (VI-VIII)',
    displayName: 'Middle School (VI-VIII)',
    level: 4,
    country: null,
    value: 4,
    label: 'Middle School (VI-VIII)',
  },
  classes: [
    {
      name: 'VI',
      level: 6,
    },
    {
      name: 'VII',
      level: 7,
    },
    {
      name: 'VIII',
      level: 8,
    },
  ],
};

const CLASS_1_TO_5 = {
  schoolLevel: {
    classes: [
      {
        name: 'I',
        level: 1,
      },
      {
        name: 'II',
        level: 2,
      },
      {
        name: 'III',
        level: 3,
      },
      {
        name: 'IV',
        level: 4,
      },
      {
        name: 'V',
        level: 5,
      },
    ],
    id: 3,
    version: 1,
    deleted: false,
    active: true,
    name: 'Primary School (I-V)',
    displayName: 'Primary School (I-V)',
    level: 3,
    country: null,
    value: 3,
    label: 'Primary School (I-V)',
  },
  classes: [
    {
      name: 'I',
      level: 1,
    },
    {
      name: 'II',
      level: 2,
    },
    {
      name: 'III',
      level: 3,
    },
    {
      name: 'IV',
      level: 4,
    },
    {
      name: 'V',
      level: 5,
    },
  ],
};

const KG_CLASSES = {
  schoolLevel: {
    classes: [
      {
        name: 'Pre-nursery',
        level: -4,
      },
      {
        name: 'Nursery',
        level: -3,
      },
      {
        name: 'Pre KG',
        level: -3,
      },
      {
        name: 'KG',
        level: -2,
      },
      {
        name: 'Pre-Reception',
        level: -2,
      },
      {
        name: 'LKG',
        level: -2,
      },
      {
        name: 'UKG',
        level: -1,
      },
      {
        name: 'Reception',
        level: -1,
      },
      {
        name: 'KG 1',
        level: -2,
      },
      {
        name: 'KG 2',
        level: -1,
      },
      {
        name: 'FS1',
        level: -2,
      },
      {
        name: 'FS2',
        level: -1,
      },
      {
        name: 'PP 1',
        level: -2,
      },
      {
        name: 'PP 2',
        level: -1,
      },
      {
        name: 'Prep',
        level: -1,
      },
    ],
    id: 2,
    version: 1,
    deleted: false,
    active: true,
    name: 'Pre Primary School (Pre School)',
    displayName: 'Pre Primary School (Pre School)',
    level: 2,
    country: null,
    value: 2,
    label: 'Pre Primary School (Pre School)',
  },
  classes: [
    {
      name: 'Nursery',
      level: -3,
    },
    {
      name: 'UKG',
      level: -1,
    },
    {
      name: 'KG',
      level: -2,
    },
    {
      name: 'LKG',
      level: -2,
    },
  ],
};

export const getSchoolLevelsList = (schoolDetails) => {
  const highestGrade = schoolDetails?.highestGrade;

  const classesKGList = [
    'Pre KG',
    ,
    'KG',
    'KG1',
    'KG2',
    'LKG',
    'UKG',
    'Pre KG',
    'Pre Nursery',
    'Nursery',
    'Pre Nursery',
  ];

  const isKGSchool = classesKGList?.includes(highestGrade);
  const fifthSchoolLevel = highestGrade === 'V';
  const eightSchoolLevel = highestGrade === 'VIII';
  const tenthSchoolLevel = highestGrade === 'X';
  const tewelthSchoolLevel = highestGrade === 'XII';

  if (isKGSchool) {
    return [KG_CLASSES];
  } else if (fifthSchoolLevel) {
    return [KG_CLASSES, CLASS_1_TO_5];
  } else if (eightSchoolLevel) {
    return [KG_CLASSES, CLASS_1_TO_5, CLASS_6_TO_8];
  } else if (tenthSchoolLevel) {
    return [KG_CLASSES, CLASS_1_TO_5, CLASS_6_TO_8, CLASS_8_TO_10];
  } else if (tewelthSchoolLevel) {
    return [KG_CLASSES, CLASS_1_TO_5, CLASS_6_TO_8, CLASS_8_TO_10, CLASS_10_TO_12];
  } else {
    return [];
  }
};
